"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var appButtons_1 = require("./scoreSystems/IfscTopBonus/appButtons");
var appButtons_2 = require("./scoreSystems/IfscTopZone/appButtons");
var appButtons_3 = require("./scoreSystems/IfscLead/appButtons");
var appButtons_4 = require("./scoreSystems/NorthFaceCup2019/appButtons");
var appButtons_5 = require("./scoreSystems/PointsDecreaseWithAttempts/appButtons");
var appButtons_6 = require("./scoreSystems/PointsGravical2019/appButtons");
var appButtons_7 = require("./scoreSystems/TopsWithAttempts/appButtons");
var appButtons_8 = require("./scoreSystems/UsacModifiedRedpoint/appButtons");
var appButtons_9 = require("./scoreSystems/UsacModifiedRedpointMultizone/appButtons");
var getAppButtons = function (key) {
    switch (key) {
        case constants_1.IFSC_TB:
            return appButtons_1.default;
        case constants_1.IFSC_TZ:
            return appButtons_2.default;
        case constants_1.IFSC_LEAD:
            return appButtons_3.default;
        case constants_1.NORTH_FACE_CUP_2019:
            return appButtons_4.default;
        case constants_1.POINTS_DECREASE:
            return appButtons_5.default;
        case constants_1.POINTS_GRAVICAL_2019:
            return appButtons_6.default;
        case constants_1.TOPS_WITH_ATTEMPTS:
            return appButtons_7.default;
        case constants_1.USAC_MOD_REDPOINT:
            return appButtons_8.default;
        case constants_1.USAC_MOD_REDPOINT_MULTIZONE:
            return appButtons_9.default;
        default:
            return [{
                    label: 'No such score format',
                    value: '-',
                    hint: 'No such score format',
                }];
    }
};
exports.default = getAppButtons;
//# sourceMappingURL=getAppButtons.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/getAppButtons.js
// module id = 376
// module chunks = 0